import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Button } from "@/shared/ui";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-4 py-24 text-center">
      <p className="text-6xl font-bold text-muted">404</p>
      <h1 className="text-xl font-semibold">{t("errors.notFoundTitle")}</h1>
      <Button asChild variant="secondary">
        <Link to="/">{t("errors.notFoundAction")}</Link>
      </Button>
    </div>
  );
}
